import { DataField } from "./DataField";

import React, { useMemo } from "react";
import { Table } from "antd";

const AdminRoleMap = {
    "lo":"Loan Officer",
    "la":"Auditor",
    "lph":"Loan Processing Head",
    "es":"Executive Secretary",
}

const LoanHistoryTable = ({ loanData }) => {
  const columns = [
    {
      title: "S/N",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Previous Amount",
      dataIndex: "from_amount",
      key: "from_amount",
      render: (amount) => `₦${amount?.toLocaleString()}`,
    },
    {
      title: "New Amount",
      dataIndex: "to_amount",
      key: "to_amount",
      render: (amount) => `₦${amount?.toLocaleString()}`,
    },
    {
      title: "Changed By",
      dataIndex: "changed_by",
      key: "changed_by",
      render: (user) => (user?.name?.replace("undefined","") || user?.email ) +  `(${AdminRoleMap[user.role] ?? AdminRoleMap.lo})`,
    },
    {
      title: "Date Changed",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => date ? new Date(date).toLocaleString() : "-",
    },
  ];

  const loanAmountHistoryData = useMemo(()=>{
    return loanData?.loan_amount_history?.sort((itemA,itemB)=>{
      const dateA = new Date(itemA.created_at)
      const dateB = new Date(itemB.created_at)

      return dateB.getTime() - dateA.getTime()
    })
  },[loanData])

  return (
    <div className="mt-4">
      <Table
        columns={columns}
        dataSource={loanAmountHistoryData ?? []}
        rowKey={(record) => record.id || Math.random()}
        pagination={false}
        bordered
        size="middle"
      />
    </div>
  );
};



export default function LoanTabInfo({ loan, loanData, adminRole, openModal }) {
  return (
    <div className="grid grid-cols-2 bg-white gap-4 p-2">
      <DataField
        label={"Loan Comment"}
        value={loan?.data[0]?.comment || "No Message available"}
      />
      <DataField
        label={"Reffered By"}
        value={loanData.reffered_by_name || "Not Reffered Yet"}
      />
      <DataField
        label={"Rejected By"}
        value={
          <p>
            {loanData.rejectedBy} - <b>{loanData.rejected_by_email}</b>
          </p>
        }
      />
      <DataField
        label={"Application Date"}
        value={new Date(loanData.created_at).toUTCString()}
      />
      <DataField
        label={"Loan Amount"}
        value={
          <>
            <p>₦{loanData?.amount.toLocaleString()}</p>
            {(loanData.status === "pending" ||
              loanData.status === "reviewing") &&
              (adminRole === "lph" || adminRole === "es") && (
                <button
                  onClick={openModal}
                  className="bg-primary-100 text-primary-800 border px-4 border-primary-400 rounded-md py-2 text-xs"
                >
                  Update Amount
                </button>
              )}
          </>
        }
      />
      <DataField
        label={"Loan Tenure"}
        value={
          loanData?.loan_tenure
            ? `${loanData?.loan_tenure} months`
            : "Not Provided"
        }
      />
      <DataField
        label={"Loan Repayment Amount"}
        value={
          loanData?.loan_tenure
            ? `₦${loanData?.monthly_repayment_amount.toLocaleString()}`
            : "Not Provided"
        }
      />
      <div className="col-span-2 bg-white p-4">
        <p className="font-medium text-sm">Loan Amount Update History</p>
        <LoanHistoryTable loanData={loanData}/>
      </div>
    </div>
  );
}
